// Shared free-tier gate copy (expansion date window, signal blur, API keys).
// Namespaced under `premium` so the gate reads the same on every surface.
export default {
  premium: {
    tag: "PRO",
    gate: {
      signalsTitle:
        "The latest signal is locked | The {n} latest signals are locked",
      signalsDesc: "Upgrade to reveal every expansion signal, from day one.",
      signalsCta: "Unlock signals",
    },
    dateWindow: {
      tip: "The free plan covers the last {n} days. Upgrade for full history.",
      lockedLabel: "Upgrade for full history",
    },
    apiKeys: {
      bannerTitle: "API access is a paid feature",
      bannerDesc:
        "Generate keys, automate exports, and query Pubrio programmatically.",
      tip: "Upgrade your plan to create API keys.",
      cta: "See plans",
    },
    team: {
      locked: "See team",
      tip: "Upgrade to see who's on the ground in this market.",
    },
    source: {
      locked: "View source",
      tip: "Upgrade to open the source behind every signal.",
    },
    employees: {
      locked: "Employee data is locked",
      tip: "Upgrade to see headcount and the people behind this company.",
      cta: "Unlock employees",
    },
    markets: {
      moreLocked: "+1 more market | +{n} more markets",
    },
  },
};
